<template>
<div>
    <!-- <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." /> -->
    <component :is="this.headerFooter.header"></component>
    <div class="container">
        <ReportInfo :reportInfo="reportInfo"/>
        <div style="margin-top:60px;">
            <b-button variant="outline-secondary" size="lg" @click="changeFeatur(0)">Original</b-button>
            <b-dropdown left text="STFT" variant="outline-secondary" size="lg" style="margin-left:20px;">
                <b-dropdown-item @click="changeFeatur(1)">interval 0.1 sec</b-dropdown-item>
                <b-dropdown-item @click="changeFeatur(2)">interval 0.05 sec</b-dropdown-item>
            </b-dropdown>
            <b-button variant="outline-secondary" size="lg" style="margin-left:20px;" @click="changeFeatur(3)">PSD</b-button>
            <b-button variant="outline-secondary" size="lg" style="margin-left:20px;" @click="changeFeatur(4)">FFT</b-button>
            <!-- <b-dropdown left text="FFT" variant="outline-secondary" size="lg" style="margin-left:20px;">
                <b-dropdown-item @click="changeFeatur(4)">Original</b-dropdown-item>
                <b-dropdown-item @click="changeFeatur(5)">Original Pressure</b-dropdown-item>
            </b-dropdown> -->
        </div>
        <ReportSTFT v-if="is_showSTFT" :type="type" :key="timer" style="margin-top:40px;" />
        <ReportChart v-if="is_showOriginal" style="margin-top:40px;" />
        <ReportPSD v-if="is_showPSD"/>
        <ReportFFT v-if="is_showFFT"/>

        <div style="margin-top:100px;">
            <b-button variant="outline-secondary" size="lg" @click="changeFeatur1(0)">Single Original</b-button>
            <b-dropdown left text="Single STFT" variant="outline-secondary" size="lg" style="margin-left:20px;">
                <b-dropdown-item @click="changeFeatur1(1)">interval 0.1 sec</b-dropdown-item>
                <b-dropdown-item @click="changeFeatur1(2)">interval 0.05 sec</b-dropdown-item>
            </b-dropdown>
            <b-button variant="outline-secondary" size="lg" style="margin-left:20px;" @click="changeFeatur1(3)">Single FiveOrder</b-button>
        </div>
        <SingleReportChart v-if="is_showSingleOriginal" />
        <SingleReportSTFT v-if="is_showSingleSTFT" :type="type1" :key="timer1"/>
        <SingleReportFiveOrder v-if="is_showSingleFiveOrder"/>
    </div>
</div>
</template>
<script>
import Header from '@/components/Header.vue';
import ReportInfo from '@/components/sp_report/report_info.vue'
// import FeaturBar from '@/components/em_report/featurBar.vue'
import ReportChart from '@/components/em_report/report_chart.vue'
import ReportSTFT from '@/components/em_report/report_stft.vue'
import ReportPSD from '@/components/em_report/report_psd.vue'
import ReportFFT from '@/components/em_report/report_fft.vue'
import SingleReportChart from '@/components/em_report/single_report_chart.vue'
import SingleReportSTFT from '@/components/em_report/single_report_stft.vue'
import SingleReportFiveOrder from '@/components/em_report/single_report_fiveOrder.vue'
import store from "@/store"
export default {
    data() {
        return {
            client_account: '',
            report_id: '',
            doc_account: 'cherng0125',
            type: '',
            type1: '',
            timer:null,
            timer1:null,
            reportInfo: [],
            is_showOriginal: true,
            is_showSTFT: false,
            is_showPSD: false,
            is_showFFT: false,
            is_showSingleOriginal: true,
            is_showSingleSTFT: false,
            is_showSingleFiveOrder: false,
            isLoading: false,
        }
    },
    components: {
        Header,
        ReportInfo,
        ReportChart,
        // FeaturBar,
        ReportSTFT,
        ReportPSD,
        ReportFFT,
        SingleReportChart,
        SingleReportSTFT,
        SingleReportFiveOrder
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        const user = JSON.parse(sessionStorage.getItem('my_info'));
        if(user === null){
            alert("请重新登入");
            this.$router.push('/login');
        }
        this.reportInfo = report
    },
    computed: {
        headerFooter() {
            return store.getters['auth/isLoggedIn'] ? {
                header: Header,
            } : {
                header: Header,
            }
        },
    },
    methods: {
        changeFeatur(tag) {
            if(tag == 0){
                this.is_showOriginal = true;
                this.is_showSTFT = false;
                this.is_showPSD = false;
                this.is_showFFT = false;
            }else if(tag == 1){
                this.is_showOriginal = false;
                this.is_showSTFT = true;
                this.is_showPSD = false;
                this.is_showFFT = false;
                this.type = 1
                this.timer = new Date().getTime();
            }else if(tag == 2){
                this.is_showSTFT = true;
                this.is_showOriginal = false;
                this.is_showPSD = false;
                this.is_showFFT = false;
                this.type = 2
                this.timer = new Date().getTime();
            }else if(tag == 3){
                this.is_showSTFT = false;
                this.is_showOriginal = false;
                this.is_showPSD = true;
                this.is_showFFT = false;
                this.type = 3
                this.timer = new Date().getTime();
            }else if(tag == 4){
                this.is_showSTFT = false;
                this.is_showOriginal = false;
                this.is_showPSD = false;
                this.is_showFFT = true;
                this.type = 4
                this.timer = new Date().getTime();
            }
        },
        changeFeatur1(tag) {
            if(tag == 0){
                this.is_showSingleOriginal = true;
                this.is_showSingleSTFT = false;
                this.is_showSingleFiveOrder = false;
            }else if(tag == 1){
                this.is_showSingleOriginal = false;
                this.is_showSingleSTFT = true;
                this.is_showSingleFiveOrder = false;
                this.type1 = 1
                this.timer1 = new Date().getTime();
            }else if(tag == 2){
                 this.is_showSingleSTFT = true;
                this.is_showSingleOriginal = false;
                this.is_showSingleFiveOrder = false;
                this.type1 = 2
                this.timer1 = new Date().getTime();
            }else if(tag == 3){
                 this.is_showSingleSTFT = false;
                this.is_showSingleOriginal = false;
                this.is_showSingleFiveOrder = true;
                this.type1 = 3
                this.timer1 = new Date().getTime();
            }
        }
    }
}
</script>